import ko = require('knockout');

ko.components.register('navigation-top-public', require('Components/Navigation/Top/TopNavigationPublicViewModel'));

ko.components.register('profile-changeSecurityQuestions', require('Components/Profile/ChangeSecurityQuestions/ChangeSecurityQuestionViewModel'));
ko.components.register('profile-updateContactInformation', require('Components/Profile/UpdateContactInformation/UpdateContactInformationViewModel'));